import api from "./core";

const basePath = "api/portal/Patients";

export default {
  async getImaginePaymentRequest(patientId) {
    const result = await api.get(`${basePath}/ImaginePaymentRequest/${patientId}`);
    return result.data;
  },
  updateLastRequestIdFetchTime(id, disable, extraHeaders = {}){
    return api.post(`${basePath}/UpdateLastRequestIdFetchTime/${id}?disable=${ disable }`,{}, extraHeaders);
  },
  processPatientPayment(id, extraHeaders = {}){
    return api.post(`${basePath}/ProcessPatientPayment/${id}`,{}, extraHeaders);
  }
};
